import { Action, createReducer, on } from '@ngrx/store';
import { StepsClientTypes, StepsNotClientTypes } from 'src/app/shared/enums';
import { UiActions } from '../actions';

export interface UiState {
    text: string;
    buttonText: string;
    icon: string | undefined;
    open: boolean;
    redirect?: StepsNotClientTypes | StepsClientTypes | undefined;
}

export const UiInitialState: UiState = {
    text: '',
    buttonText: 'Continue',
    icon: '',
    open: false,
    redirect: undefined
};

const reducer = createReducer(
    UiInitialState,
    on(UiActions.ToggleModal, (state, {text, buttonText, icon, open, redirect}) => ({
        ...state,
        text,
        buttonText,
        icon,
        open,
        redirect
    })),
    on(UiActions.Navigate, (state, { step }) => ({
        ...state,
        redirect: undefined
    })),
    on(UiActions.ModalResolution, (state) => ({
        ...state,
        open: false
    }))
);

export function uiReducer(state: UiState, action: Action) {
    return reducer(state, action);
}
